import { useEffect, useState } from 'react';
import { getLocaleData, LocaleData } from '@mb/lib/i18n';
import { IntlProvider } from 'react-intl';
import { HeaderContent } from './components/HeaderContent/HeaderContent';
import { ImageCarousel } from './components/ImageCarousel/ImageCarousel';
import { HeaderContainer } from './containers/HeaderContainer';
import { useCollectionHeader } from './hooks/useCollectionHeader';
import { GalleryContext, useGalleryContext } from './hooks/useGalleryContext';

export const CollectionHeader = () => {
  const { campaign, showHeader } = useCollectionHeader();
  const galleryCtx = useGalleryContext();
  const [langData, setLangData] = useState<LocaleData>({
    currentLocale: 'en',
    messages: undefined,
  });
  const hasImages =
    campaign?.header_inspiration_images &&
    campaign.header_inspiration_images.length > 0;

  useEffect(() => {
    if (galleryCtx.fullScreenActive) {
      document.body.style.overflowY = 'hidden';
    } else {
      document.body.style.overflowY = 'auto';
    }
  }, [galleryCtx.fullScreenActive]);

  useEffect(() => {
    handleLangData();
  }, []);

  const handleLangData = async () => {
    const data = await getLocaleData();
    setLangData(data);
  };

  return (
    <GalleryContext.Provider value={galleryCtx}>
      <IntlProvider
        messages={langData?.messages}
        locale={langData?.currentLocale}
        defaultLocale="en"
      >
        <HeaderContainer
          show={showHeader}
          backgroundColor={campaign?.header_background_color}
        >
          <HeaderContent campaign={campaign} />
          {hasImages && <ImageCarousel campaign={campaign} />}
        </HeaderContainer>
      </IntlProvider>
    </GalleryContext.Provider>
  );
};
